import { useRouter } from "next/router";
import React, { useContext, useState, useTransition } from "react";
import { useForm } from "react-hook-form";
import teamModel from "../../models/team.model";
import Heading from "../../components/Heading";
import helper from "../../lib/helper";
import _ from "lodash";
import { Card } from "react-bootstrap";
import vendorModel from "../../models/vendor.model";
import commonModel from "../../models/common.model";
const Page = function () {
  const router = useRouter();
  const [preview, setPreview] = useState(
    "http://ssl.gstatic.com/accounts/ui/avatar_2x.png",
  );
  const [showLoader, setShowLoader] = useState(false);
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors, isSubmitting },
    setError,
  } = useForm();

  const onSelectFile = (e) => {
    const objectUrl = URL.createObjectURL(e.target.files[0]);
    setPreview(objectUrl);
    //setValue("avatar", e.target.files[0]);
  };

  const searchPincode = async (pincode, type) => {
    console.log(type, pincode);
    await commonModel.searchPincode(pincode).then((results) => {
      setValue(`${type}.city`, results?.data?.city);
      setValue(`${type}.state`, results?.data?.state);
    });
  };

  const onSubmit = handleSubmit(async (data, event) => {
    const formData = new FormData(event.target);
    await vendorModel
      .create(formData)
      .then((response) => {
        helper.sweetalert.toast(response.data?.message);
        router.push("/vendors");
      })
      .catch((error) => {
        helper.sweetalert.toast(error.response.data?.message, "error");
        _.each(error.response?.data?.errors, function (err, errorKey) {
          setError(errorKey, { type: "required", message: err });
        });
      });
  });

  return (
    <>
      <Heading title=" Create Vendor " showLoader={showLoader} />
      <form onSubmit={onSubmit} className="container-fluid">
        <input type="hidden" name="register[type]" value="register" />
        <input type="hidden" name="pickup[type]" value="pickup" />
        <div className="card col-md-12">
          <div className="card-header">Create Vendor</div>
          <div className="card-body row">
            <div className="col-md-3 me-3 position-relative border-end">
              <img src={preview} className="w-100 border rounded" alt="" />
              <div className="m-1">
                <label className="custom-file-upload">
                  <input
                    type="file"
                    className="d-none"
                    accept="image/*"
                    {...register("avatar", { onChange: onSelectFile })}
                  />
                  <b className="btn btn-dark">Upload</b>
                </label>
              </div>
            </div>
            <div className="col-md-9 row">
              <div className="col-md-6 form-group">
                <label className="form-label">Name</label>
                <input
                  type="text"
                  placeholder="Enter Name"
                  className={`form-control ${errors?.name && "is-invalid"}`}
                  {...register("name", {
                    required: "Name is required",
                  })}
                />
              </div>
              <div className="col-md-6 form-group">
                <label className="form-label">Legal-Name</label>
                <input
                  type="text"
                  placeholder="Enter Legal Name"
                  className={`form-control ${errors?.legal_name && "is-invalid"}`}
                  {...register("info[legal_name]", {
                    required: "Legal name is required",
                  })}
                />
                <div className="invalid-feedback">
                  {errors?.info?.legal_name && errors?.info?.legal_name.message}
                </div>
              </div>
              <div className="col-md-6 form-group">
                <label className="form-label">PAN number</label>
                <input
                  type="text"
                  placeholder="Enter PAN Number"
                  className={`text-uppercase form-control ${errors?.info?.pan_number && "is-invalid"}`}
                  {...register("info[pan_number]", {
                    required: "PAN number is required",
                  })}
                />
                <div className="invalid-feedback">
                  {errors?.info?.pan_number && errors?.info?.pan_number.message}
                </div>
              </div>
              <div className="col-md-6 form-group">
                <label className="form-label">GST number</label>
                <input
                  type="text"
                  placeholder="Enter GST Number"
                  className={`text-uppercase form-control ${errors?.info?.gst_number && "is-invalid"}`}
                  {...register("info[gst_number]", {
                    required: "GST number is required",
                  })}
                />
                <div className="invalid-feedback">
                  {errors?.info?.gst_number && errors?.gst_number.message}
                </div>
              </div>
              <div className="col-md-6 form-group">
                <label className="form-label">Email</label>
                <input
                  placeholder="Enter Email"
                  type="email"
                  className={`form-control ${errors?.email && "is-invalid"}`}
                  {...register("email", { required: true })}
                />
                <div className="invalid-feedback">
                  {errors.email && errors.email.message}
                </div>
              </div>
              <div className="col-md-6 form-group">
                <label className="form-label">Mobile</label>
                <input
                  placeholder="Enter Mobile"
                  type="text"
                  className={`form-control ${errors?.mobile && "is-invalid"}`}
                  {...register("mobile", { required: true })}
                />
                <div className="invalid-feedback">
                  {errors.mobile && errors.mobile.message}
                </div>
              </div>
              <div className="col-md-6 form-group">
                <label className="form-label">Password</label>
                <input
                  placeholder="Enter Password"
                  type="password"
                  className={`form-control ${errors?.password && "is-invalid"}`}
                  {...register("password", { required: true })}
                />
                <div className="invalid-feedback">
                  {errors.password && errors.password.message}
                </div>
              </div>
              <div className="col-md-6 form-group">
                <label className="form-label">ConfirmPassword</label>
                <input
                  placeholder="Enter ConfirmPassword"
                  type="password"
                  className={`form-control ${errors?.password_confirmation && "is-invalid"}`}
                  {...register("password_confirmation", { required: true })}
                />
                <div className="invalid-feedback">
                  {errors.password_confirmation &&
                    errors.password_confirmation.message}
                </div>
              </div>

              <div className="col-md-6 form-group">
                <label className="form-label">Code</label>
                <input
                  placeholder="Enter Code"
                  type="text"
                  className={`form-control ${errors?.code && "is-invalid"}`}
                  {...register("info[code]", { required: true })}
                />
                <div className="invalid-feedback">
                  {errors.code && errors.code.message}
                </div>
              </div>
            </div>
          </div>
          <div className="card-header">Documents</div>
          <div className="card-body row">
            <div className="col-md-2 position-relative">
              <label className="form-label">Pancard</label>
              <input type="file" name="pancard_image" />
            </div>

            <div className="col-md-2 position-relative">
              <label className="form-label">Cancel Cheque</label>
              <input type="file" name="cancel_cheque_image" />
            </div>
          </div>
          <div className="card-header">Bank information</div>
          <div className="card-body row">
            <div className="col-md-4 form-group">
              <label className="form-label">Account Name</label>
              <input
                placeholder="Account Name"
                type="text"
                className={`form-control ${errors?.info?.bank?.name && "is-invalid"}`}
                {...register("info[bank][name]", { required: true })}
              />
              <div className="invalid-feedback">
                {errors?.info?.bank?.name && errors?.info?.bank?.name.message}
              </div>
            </div>
            <div className="col-md-4 form-group">
              <label className="form-label">Account IFSC</label>
              <input
                placeholder="Account IFSC"
                type="text"
                className={`form-control ${errors?.info?.bank?.ifsc && "is-invalid"}`}
                {...register("info[bank][ifsc]", { required: true })}
              />
              <div className="invalid-feedback">
                {errors?.info?.bank?.ifsc && errors?.info?.bank?.ifsc.message}
              </div>
            </div>
            <div className="col-md-4 form-group">
              <label className="form-label">Account Number</label>
              <input
                placeholder="Account Number"
                type="text"
                className={`form-control ${errors?.info?.bank?.number && "is-invalid"}`}
                {...register("info[bank][number]", { required: true })}
              />
              <div className="invalid-feedback">
                {errors?.info?.bank?.name && errors?.info?.bank?.name.message}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <Card.Header>Registered Address</Card.Header>
              <Card.Body>
                <div className="row">
                  <div className="col-md-6">
                    <label className="form-label">Name</label>
                    <input
                      type="text"
                      className={`form-control ${errors?.register?.name && "is-invalid"}`}
                      {...register("register[name]", { required: true })}
                    />
                    <div className="invalid-feedback">
                      {errors?.register?.name && errors?.register?.name.message}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Mobile</label>
                    <input
                      type="text"
                      className={`form-control ${errors?.register?.mobile && "is-invalid"}`}
                      {...register("register[mobile]", { required: true })}
                    />
                    <div className="invalid-feedback">
                      {errors?.register?.mobile &&
                        errors?.register?.mobile.message}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Line 1</label>
                    <input
                      type="text"
                      className={`form-control ${errors?.register?.line_1 && "is-invalid"}`}
                      {...register("register[line_1]", { required: true })}
                    />
                    <div className="invalid-feedback">
                      {errors?.register?.line_1 &&
                        errors?.register?.line_1.message}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Line 2</label>
                    <input
                      type="text"
                      className={`form-control ${errors?.register?.line_2 && "is-invalid"}`}
                      {...register("register[line_2]", { required: true })}
                    />
                    <div className="invalid-feedback">
                      {errors?.register?.line_2 &&
                        errors?.register?.line_2.message}
                    </div>
                  </div>
                  <div className="col-md-6 form-group">
                    <label className="form-label">Locality</label>
                    <input
                      type="text"
                      className={`form-control ${errors?.register?.locality && "is-invalid"}`}
                      {...register("register[locality]", { required: true })}
                    />
                    <div className="invalid-feedback">
                      {errors?.register?.locality && errors?.register?.message}
                    </div>
                  </div>
                  <div className="col-md-6 form-group">
                    <label className="form-label">Pincode</label>
                    <input
                      type="text"
                      className={`form-control ${errors?.register?.pincode && "is-invalid"}`}
                      {...register("register[pincode]", {
                        required: true,
                        onChange: (event) =>
                          searchPincode(event.target.value, "register"),
                      })}
                    />
                    <div className="invalid-feedback">
                      {errors?.register?.pincode &&
                        errors?.register?.pincode.message}
                    </div>
                  </div>

                  <div className="col-md-6 form-group">
                    <label className="form-label">City</label>
                    <input
                      type="text"
                      readOnly
                      className={`form-control ${errors?.register?.city && "is-invalid"}`}
                      {...register("register[city]", { required: true })}
                    />
                    <div className="invalid-feedback">
                      {errors?.register?.city && errors?.register?.city.message}
                    </div>
                  </div>
                  <div className="col-md-6 form-group">
                    <label className="form-label">State</label>
                    <input
                      type="text"
                      readOnly
                      className={`form-control ${errors?.register?.state && "is-invalid"}`}
                      {...register("register[state]", { required: true })}
                    />
                    <div className="invalid-feedback">
                      {errors?.register?.state &&
                        errors?.register?.state.message}
                    </div>
                  </div>
                </div>
              </Card.Body>
            </div>
            <div className="col-md-6">
              <Card.Header>Pickup Address</Card.Header>
              <Card.Body>
                <div className="row">
                  <div className="col-md-6">
                    <label className="form-label">Name</label>
                    <input
                      type="text"
                      className={`form-control ${errors?.pickup?.name && "is-invalid"}`}
                      {...register("pickup[name]", { required: true })}
                    />
                    <div className="invalid-feedback">
                      {errors?.pickup?.name && errors?.pickup?.name.message}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Mobile</label>
                    <input
                      type="text"
                      className={`form-control ${errors?.pickup?.mobile && "is-invalid"}`}
                      {...register("pickup[mobile]", { required: true })}
                    />
                    <div className="invalid-feedback">
                      {errors?.pickup?.mobile && errors?.pickup?.mobile.message}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Line 1</label>
                    <input
                      type="text"
                      className={`form-control ${errors?.pickup?.line_1 && "is-invalid"}`}
                      {...register("pickup[line_1]", { required: true })}
                    />
                    <div className="invalid-feedback">
                      {errors?.pickup?.line_1 && errors?.pickup?.line_1.message}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Line 2</label>
                    <input
                      type="text"
                      className={`form-control ${errors?.line_2 && "is-invalid"}`}
                      {...register("pickup[line_2]", { required: true })}
                    />
                    <div className="invalid-feedback">
                      {errors?.pickup?.line_2 && errors?.pickup?.line_2.message}
                    </div>
                  </div>
                  <div className="col-md-6 form-group">
                    <label className="form-label">Locality</label>
                    <input
                      type="text"
                      className={`form-control ${errors?.pickup?.locality && "is-invalid"}`}
                      {...register("pickup[locality]", { required: true })}
                    />
                    <div className="invalid-feedback">
                      {errors?.pickup?.locality &&
                        errors?.pickup?.locality.message}
                    </div>
                  </div>
                  <div className="col-md-6 form-group">
                    <label className="form-label">Pincode</label>
                    <input
                      type="text"
                      className={`form-control ${errors?.pickup?.pincode && "is-invalid"}`}
                      {...register("pickup[pincode]", {
                        required: true,
                        onChange: (event) =>
                          searchPincode(event.target.value, "pickup"),
                      })}
                    />
                    <div className="invalid-feedback">
                      {errors?.pickup?.pincode &&
                        errors?.pickup?.pincode.message}
                    </div>
                  </div>

                  <div className="col-md-6 form-group">
                    <label className="form-label">City</label>
                    <input
                      type="text"
                      readOnly
                      className={`form-control ${errors?.pickup?.city && "is-invalid"}`}
                      {...register("pickup[city]", { required: true })}
                    />
                    <div className="invalid-feedback">
                      {errors?.pickup?.city && errors?.pickup?.city.message}
                    </div>
                  </div>
                  <div className="col-md-6 form-group">
                    <label className="form-label">State</label>
                    <input
                      type="text"
                      readOnly
                      className={`form-control ${errors?.pickup?.state && "is-invalid"}`}
                      {...register("pickup[state]", { required: true })}
                    />
                    <div className="invalid-feedback">
                      {errors?.pickup?.state && errors?.pickup?.state.message}
                    </div>
                  </div>
                </div>
              </Card.Body>
            </div>
          </div>
          <div className="card-footer">
            <button
              type="submit"
              disabled={isSubmitting ? "disabled" : ""}
              className="btn btn-primary float-end"
            >
              Save
            </button>
          </div>
        </div>
      </form>
    </>
  );
};

export default Page;
